<template>
  <div style="min-width:1290px;">
    <MyBanner />
    <MyRight />
    <div>
      <div class="w1200">
        <div style="padding:20px 0;">
          <el-breadcrumb :separator-icon="ArrowRight">
            <el-breadcrumb-item>当前位置：</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>鹏飞简介</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="content">
          <div style="display: flex;justify-content: space-between;">
            <div style="height: 225px;"><img src="./../static/ab.png" alt="" style="width: 400px;height: 225px;"></div>
            <div style="width: 790px;height: 225px;display: flex;flex-direction: column;justify-content: space-between">
              <div style="font-size: 24px;font-weight: 700;">山西鹏飞集团有限公司</div>
              <div style="font-size: 16px;color: rgba(153, 153, 153, 1);">PENGFEI GROUP</div>
              <div style="font-size: 16px;color: rgba(68, 68, 68, 1);line-height: 29px;">山西鹏飞集团有限公司（以下简称“鹏飞”）始创于1993年，从2.5万元起步，历经三十余载砥砺奋进，现已发展成为资产规模超1500亿元、员工3万余人的大型综合性能源企业集团。鹏飞始终秉承“为心系鹏飞事业的人创造幸福”的企业使命，锚定“成为全球领先的清洁能源智慧企业”的宏伟愿景，在践行国家“双碳”战略中勇立潮头，走出了一条高端化、差异化、集约化、循环化和环境友好、国际合作的高质量发展之路。</div>
            </div>
          </div>
          <div style="font-size: 20px;margin-top:60px;font-weight: 700;">有基础：筑牢传统能源根基，构建循环产业体系</div>
          <div>
            <div style="text-indent: 2em;font-size: 16px;color: rgba(68, 68, 68, 1);line-height: 29px;margin-top:10px;">
              鹏飞以传统能源为根基，依托3000万吨原煤产能、3400万吨精煤洗选能力及500万吨焦炭产能，不断延伸产业链，构建了煤-焦-化完整产业链，率先实现了同一工艺路线规模化生产30万吨甲醇、2亿立方LNG、10万吨合成氨，持续推动传统能源清洁高效利用。我们推动焦炭制造过程中超低排放与煤炭生产的绿色矿山建设。通过引入先进的污染治理技术和数字化监控平台，我们实现了对废气、废水、废物的精准管理与达标排放，部分指标远超国家标准。我们大力推动“绿色矿山”建设，将生态修复贯穿于矿产资源开发的全过程，让矿区重披绿装，再现生机。真正将环保从“末端治理”变为“源头管控”和“过程优化”，让传统产业焕发出智能化、绿色化的新貌，真正实现了全生命周期的绿色控制！
            </div>
          </div>
          <div style="font-size: 20px;margin-top:20px;font-weight: 700;">有未来：布局氢能全产业链，引领绿色能源革命</div>
          <div>
            <div style="text-indent: 2em;font-size: 16px;color: rgba(68, 68, 68, 1);line-height: 29px;margin-top:10px;">
              鹏飞集团将氢能作为核心战略方向，自2019年起高标准规划建设鹏湾氢港氢能产业园，实现从制氢、储运、加注、应用、研发及装备制造、零碳物流的全链贯通。
            </div>
            <div style="text-indent: 2em;font-size: 16px;color: rgba(68, 68, 68, 1);line-height: 29px;margin-top:10px;">
              <span style="font-weight: 700; font-size: 16px;">制氢：</span>一期2万吨/年焦炉煤气制高纯氢项目于 2022 年投产。利用焦化干熄焦余热发电配套的 3×500Nm³/h水电解制绿氢示范项目于2023年11月投运。
            </div>
            <div style="text-indent: 2em;font-size: 16px;color: rgba(68, 68, 68, 1);line-height: 29px;margin-top:10px;">
              <span style="font-weight: 700; font-size: 16px;">加氢：</span>建成投运了4座加氢综合能源岛，兼具加氢、加油、加气、充电及非油综合功能。
            </div>
            <div style="text-indent: 2em;font-size: 16px;color: rgba(68, 68, 68, 1);line-height: 29px;margin-top:10px;">
              <span style="font-weight: 700; font-size: 16px;">氢能研发：</span>与上海交大林忠钦院士团队、同济大学余卓平教授团队、太原理工大学黄庆学院士团队以及清华、北大、中科院等科研团队展开深入合作。与上海交大等单位共同申报的国家重点研发计划“氢能技术”重点专项获得国家科技部批准；获批山西省氢能成果转化基地、中试基地，鹏飞集团牵头制定了8项制氢工艺团体标准，参与制定了3项国家标准。
            </div>
            <div style="text-indent: 2em;font-size: 16px;color: rgba(68, 68, 68, 1);line-height: 29px;margin-top:10px;">
              <span style="font-weight: 700; font-size: 16px;">装备制造：</span>2022年，并购东风特种汽车制造有限公司，取得整车制造资质和制造能力后，于2025年3月，建成投用了鹏飞智创30万辆/年汽车制造产业园，实现了“核心零部件-整车制造”一体化能力的全面落地。2025年9月，发布了鹏飞智姿牌系列6款新型氢能重卡，在轻量化和能耗上实现了突破性进展，已成功交付2500辆氢能重卡，获得用户认可，成为全国氢能重卡销售量最多的汽车企业。
            </div>
            <div style="text-indent: 2em;font-size: 16px;color: rgba(68, 68, 68, 1);line-height: 29px;margin-top:10px;">
              <span style="font-weight: 700; font-size: 16px;">氢能应用：</span>截至目前，鹏飞集团累计投运氢能车辆1440辆，涵盖鹏飞氢能重卡、氢能中巴、氢能大巴、氢能装载机、氢能两轮车等多种车型，前期投运的300辆氢能重卡，总行驶里程突破5500万公里，累计减碳6万余吨，形成了全国规模最大、氢能车辆最多、运营里程数最长、应用场景最丰富的氢能全产业链发展模式，让每一辆重卡从移动的污染源变成移动式的零碳排放的清洁器，为氢能发展探索出了一条创新路径。
            </div>
            <div style="text-indent: 2em;font-size: 16px;color: rgba(68, 68, 68, 1);line-height: 29px;margin-top:10px;">
              <span style="font-weight: 700; font-size: 16px;">零碳物流：</span>自主研发零碳智慧物流管理平台，解决进入平台的物流公司及个人持有车辆、提供货源、无缝调度、能源供给、智慧加注、货到结算、车辆处置等物流全生命周期的各种问题，实现全生命陪伴，全生命无忧，打造了具有鹏飞特色的新时代大宗物料智能物流体系，构建了“造车、能源、运力”三位一体的智能运营体系，树立全国零碳物流新标杆。
            </div>
            <div style="text-indent: 2em;font-size: 16px;color: rgba(68, 68, 68, 1);line-height: 29px;margin-top:10px;">
              2025年，鹏飞集团氢能项目成功入选国家能源领域首批氢能项目试点名单。在国家“双碳”战略及山西省“建设国家资源型经济转型综合配套改革试验区”的政策机遇下，鹏飞集团将以山西吕梁孝义为支点，着力构建覆盖晋、冀、京、津、蒙、陕、甘、宁、疆的氢能应用场景，擘画“贯通万里氢能走廊，推广百万辆氢能重卡，建设百万吨氢能源供给基地，布局千座综合能源岛，打造千亿级氢能产业集群”的宏伟蓝图，真正将能源的饭碗牢牢端在自己手中，构筑零碳生态，让天更蓝、山更绿、水更清、环境更宜居！
            </div>
          </div>
          <div style="font-size: 20px;margin-top:20px;font-weight: 700;">有生活：融合文商旅多元业态，创造幸福美好生活</div>
          <div>
            <div style="text-indent: 2em;font-size: 16px;color: rgba(68, 68, 68, 1);line-height: 29px;margin-top:10px;">
              在企业治理这条路上，鹏飞始终坚信，最持久、最深厚的力量，源于文化的滋养和浸润。孝是道德的根本，义是商贾的根本。作为从孝义这片土地成长起来的企业，“孝 ”和“义 ”的精神早已融入鹏飞的血脉，深植于每个鹏飞人心中。鹏飞在千年老城的孝义打造亦古亦今、亦新亦旧的北方江南，让一座城焕发出时代的精神和历史的沉淀；在太原古县城与新华网、新华社山西分社、游戏科学联合打造「黑神话:悟空」遇见山西——古建数字艺术展，让数字科技与古建文化融合共生，实现生态价值与社会价值的协同共创；在湘峪古堡、柳氏民居更是有数不胜数的历史文化，让现代的人潮赞叹出历史的伟大改变了许许多多的年轻人的价值观！
            </div>
            <div style="text-indent: 2em;font-size: 16px;color: rgba(68, 68, 68, 1);line-height: 29px;margin-top:10px;">
              对美好生活的向往是每一个人的思念，鹏飞用不需要提醒的自觉的行动，投入到方方面面的爱心阵地。持续拓展酒店、地产等多元业态，在天津、吕梁、晋城、阳泉、长治等地打造高品质生活空间与星级酒店服务，推动城市功能升级与生活品质提升。在社会责任的道路上，鹏飞会一直走下去！
            </div>
            <div style="text-indent: 2em;font-size: 16px;color: rgba(68, 68, 68, 1);line-height: 29px;margin-top:10px;">
              鹏飞集团坚持“国家战略就是鹏飞最大的战略，时代步伐就是鹏飞前进的方向”，鹏飞连续五年跻身中国企业500强，连续七年中国民营企业500强，是山西省氢能产业链链主企业，荣获“山西省两化融合示范企业”“山西首家DCMM认证企业”等多项荣誉。站在新的历史起点，鹏飞正以改革者的勇气和担当，坚定走好具有竞争力、有优势、有特色的发展之路，凝心聚力，为实现中国式现代化贡献鹏飞力量！
            </div>
          </div>
        </div>
      </div>
    </div>
    <MyFooter />
  </div>
</template>
<script setup>
import { ref, onMounted } from "vue";
import MyRight from "@/components/RightFixd.vue";
import MyBanner from "@/components/MyBanner.vue";
import MyFooter from "@/components/MyFooter.vue";
import { ArrowRight } from '@element-plus/icons-vue'
import { useRouter } from "vue-router";
import { } from "@/api/index.js"
const router = useRouter();
onMounted(async () => { });
</script>
<style scoped>
.w1200 {
  width: 1300px;
  margin: 0 auto;
}
.content {
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
  padding: 30px;
  box-sizing: border-box;
  margin-bottom: 20px;
}
</style>